import type { TFunction } from 'i18next';

export interface ReportPropertiesDisplaySource {
    propertyCount: number;
    properties?: Array<{
        propertyName?: string | null;
    }>;
}

export function getPropertiesDisplayLabel(
    dto: ReportPropertiesDisplaySource,
    t: TFunction,
): string {
    const properties = dto.properties ?? [];

    if (dto.propertyCount === 1 && properties.length === 1) {
        return properties[0].propertyName ?? t('report.noValue');
    }

    if (dto.propertyCount > 0) {
        if (dto.propertyCount === 1) {
            return t('report.propertiesCountOne');
        }

        return t('report.propertiesCountOther', {
            count: dto.propertyCount,
        });
    }

    return t('report.noValue');
}

export function getPropertiesTooltip(
    dto: ReportPropertiesDisplaySource,
): string | null {
    if (!dto.properties || dto.properties.length <= 1) {
        return null;
    }

    const names = dto.properties
        .map((p) => p.propertyName)
        .filter((name): name is string => Boolean(name?.trim()))
        .sort((a, b) =>
            a.localeCompare(b, undefined, {
                sensitivity: 'base',
            }),
        );

    if (!names.length) {
        return null;
    }

    return names.join('\n');
}
